(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-video-stories"]) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const initialize = (root) => {
      root.querySelectorAll('[data-video-stories]').forEach((section) => {
        if (instances.has(section)) return;
        const videos = Array.from(section.querySelectorAll('video'));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const visible = new Set();
        const manuallyPaused = new Set();
        const play = (video) => {
          const attempt = video.play();
          if (attempt) attempt.catch(() => {});
        };
        const update = () => {
          videos.forEach((video) => {
            if (!document.hidden && !reduced.matches && visible.has(video) && !manuallyPaused.has(video)) play(video);
            else video.pause();
          });
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= .15) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          update();
        }, { threshold: [0, .15] });
        const handlers = new Map();
        videos.forEach((video) => {
          video.controls = false;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.tabIndex = 0;
          const toggle = () => {
            if (video.paused) { manuallyPaused.delete(video); play(video); }
            else { manuallyPaused.add(video); video.pause(); }
          };
          const key = (event) => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
          };
          video.addEventListener('click', toggle);
          video.addEventListener('keydown', key);
          handlers.set(video, { toggle, key });
          observer.observe(video);
        });
        update();
        document.addEventListener('visibilitychange', update);
        reduced.addEventListener('change', update);
        instances.set(section, () => {
          observer.disconnect();
          document.removeEventListener('visibilitychange', update);
          reduced.removeEventListener('change', update);
          videos.forEach((video) => {
            video.pause();
            video.removeEventListener('click', handlers.get(video).toggle);
            video.removeEventListener('keydown', handlers.get(video).key);
          });
          instances.delete(section);
        });
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-video-stories]').forEach((section) => {
        const cleanup = instances.get(section);
        if (cleanup) cleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
